import { Title } from "@mantine/core";


export function EditProject(): JSX.Element {
  

  return (
    <>
      <Title>Can admin edit the project? Do we actully need this screen</Title>
    </>
  );
}
